export default __webpack_public_path__ + "static/media/game-avatar.c660d067.jpg";